<template>
  <div>
    <span
      v-if="usuario"
      class="ola">
      Olá, {{ usuario.nome }} - {{ usuario.filial.nome }} - v1.3
    </span>
    <b-dropdown
      class="usuarioMenu"
      variant="link"
      no-caret>
      <template slot="button-content">
        <bImg
          class="imagem"
          rounded="circle"
          :src="require('@/images/user.svg')"/>
      </template>

      <b-dropdown-item
        :to="{ name: 'rota-perfil-alteracao'}">
        Alterar dados
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown'
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import bImg from 'bootstrap-vue/es/components/image/img'

export default {
  components: {
    bDropdown,
    bDropdownItem,
    bImg,
  },
  data() {
    return {
      usuario: null,
    }
  },
  mounted() {
    this.buscaDadosUsuarioLogado()
  },
  methods: {
    buscaDadosUsuarioLogado() {
      this.usuario = this.$store.getters['autenticacao/userObj'].usuario
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/colors.scss";

.imagem {
  width: 36px;
  height: 36px;
}

.ola {
  color: $cor-fonte-clara;
}

</style>
